import { Box } from "@mui/material"
import Paragraph from "../../../../shared/UI/Paragraph"

interface Props {
  pendingManAuthHours: number
}

function RTWPendingManAuthAlert({ pendingManAuthHours }: Props) {
  return (
    <Box
      sx={{
        backgroundColor: '#FEF0C7',
        borderRadius: '16px',
        padding: '12px 16px',
      }}
    >
      <Paragraph weight="bold" size="13px" sx={{ marginBottom: '4px' }}>
        Pending Discretionary Pay
      </Paragraph>
      <Paragraph size="13px" sx={{ color: '#000000' }}>
        There are 
        {' '}
        {pendingManAuthHours}
        {' '}
        hours of Discretionary Pay pending approval. Submitting the RTW for this absence will
        {' '}
        cancel these requests and the employee will not receive payment for these hours.
      </Paragraph>
    </Box>
  )
}

export default RTWPendingManAuthAlert